import React, { useCallback, useState } from "react";
import { AttributionContext } from "./attributionContext";

import { useAppContext } from "../../lib/appContext";
import { initEventTracker } from "../../modules/common/eventTracker";
import { useSendPageView } from "../../modules/common/eventTracker/useSendPageView";

const isClient = typeof window !== "undefined";

export const AttributionProvider: React.FC = ({ children }) => {
  const { countryCode } = useAppContext();

  if (isClient && window.co_snowplow === undefined) {
    initEventTracker(countryCode);
  }

  const [pageView, setPageView] = useState({});

  if (isClient) {
    useSendPageView(setPageView);
  }

  const getAttribution = useCallback(() => ({ pageView }), [pageView]);

  return (
    <AttributionContext.Provider value={getAttribution}>{children}</AttributionContext.Provider>
  );
};
